import { UserPlusIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const NewUser = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <UserPlusIcon size={Sizes[size]} {...rest} />;
};

NewUser.displayName = 'NewUser';
